import type { SearchView } from "./useSearchView";

export type DisplayPreferences = {
    searchView?: SearchView;
};

export default function useDisplayPreferences() {
    // sameSite: "lax" ensures the cookie is sent on top-level cross-site navigations
    // (e.g. arriving from a search engine), so SSR sees the preference on first load.
    // secure mirrors the request protocol, following the same pattern as useInitializeState.
    const { protocol } = useRequestURL();
    const preferences = useCookie<DisplayPreferences>("prefs", {
        sameSite: "lax",
        path: "/",
        maxAge: 60 * 60 * 24 * 365, // 1 year; refreshed on every write
        secure: protocol === "https:",
        default: () => ({}),
    });

    function updatePreferences(partial: Partial<DisplayPreferences>) {
        preferences.value = { ...preferences.value, ...partial };
    }

    return { preferences, updatePreferences };
}
